import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { getUserStudyPlan } from 'actions/verdicts';
import { getUserSubjects } from 'actions/user';
import { getAdditionalAdjustments, createAdditionalAdjustment, createStudentAdjustment } from 'actions/additional_adjustments';
import { searchCourseByTitle } from 'actions/search';
import moment from 'moment';
import { Button, Checkbox, Icon } from '@haldor/ui';
import { Spinner } from 'UI';
import { Editor } from 'UI/Inputs';

var StudentAdjustmentForm = /*#__PURE__*/function (_Component) {
  _inherits(StudentAdjustmentForm, _Component);

  var _super = _createSuper(StudentAdjustmentForm);

  function StudentAdjustmentForm(props) {
    var _this;

    _classCallCheck(this, StudentAdjustmentForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getAdditionalAdjustments();

      if (_this.props.userId != null) {
        _this.props.getUserSubjects(_this.props.userId).then(function () {
          var selectedSubjects = _toConsumableArray(_this.state.selectedSubjects);

          if (_this.props.userSubjects != null && _this.props.userSubjects.length > 0) {
            if (_this.props.subjectId != null) {
              _this.props.userSubjects.forEach(function (subject) {
                if (subject.id == _this.props.subjectId) {
                  selectedSubjects.push(subject);
                }
              });
            }

            if (_this.props.course != null) {
              _this.props.userSubjects.forEach(function (subject) {
                if (_this.props.course.subjectCode == subject.subjectCode) {
                  selectedSubjects.push(subject);
                }
              });
            }

            _this.setState({
              loading: false,
              selectedSubjects: selectedSubjects
            });
          } else {
            _this.setState({
              loading: false
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value != 'undefined' && value != '' && value != null) {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "editorRequired", function (value) {
      if (typeof value != 'undefined' && value != '' && value != null) {
        return undefined;
      }

      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        values.subjects = _this.state.selectedSubjects;

        if (_this.props.initialValues == null) {
          values.status = 'ACTIVE';
          values.studentId = _this.props.userId;
          values.startDate = moment().format('YYYY-MM-DD');
        }

        if (values.subTitle != null) {
          var adjustmentObj = {
            title: _this.props.translate('other'),
            subTitle: values.subTitle,
            description: values.adjustmentDescription
          };

          _this.props.createAdditionalAdjustment(adjustmentObj).then(function () {
            values.adjustmentId = _this.props.createdAdjustment.id;

            _this.props.createStudentAdjustment(values).then(function () {
              resolve(1);

              _this.props.onClose();
            });
          });
        } else {
          values.adjustmentId = _this.state.category;

          _this.props.createStudentAdjustment(values).then(function () {
            resolve(1);

            _this.props.onClose();
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onClose != null) {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCategoryChange", function (event) {
      _this.setState({
        category: event.target.value
      });

      var category = _this.props.additionalAdjustments.find(function (adjustment) {
        return adjustment.id == parseInt(event.target.value, 10);
      });

      if (category != null) {
        _this.props.change('description', category.description, null);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectAllSubjects", function () {
      var selectedSubjects = _this.state.selectedSubjects;

      if (_this.props.userSubjects == null) {
        return false;
      }

      var selectedAmount = selectedSubjects.length;
      selectedSubjects = [];

      if (selectedAmount != _this.props.userSubjects.length) {
        _this.props.userSubjects.forEach(function (subject) {
          selectedSubjects.push(subject);
        });
      } else {
        _this.props.userSubjects.forEach(function (subject) {
          var disabled = false;

          if (_this.props.course != null) {
            disabled = _this.props.course.subjectCode == subject.subjectCode;
          }

          if (_this.props.subjectId != null) {
            disabled = _this.props.subjectId == subject.id;
          }

          if (disabled) {
            selectedSubjects.push(subject);
          }
        });
      }

      _this.setState({
        selectedSubjects: selectedSubjects
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubjectToggle", function (subject) {
      var selectedSubjects = _toConsumableArray(_this.state.selectedSubjects);

      var found = _this.state.selectedSubjects.findIndex(function (sel) {
        return sel.id == subject.id;
      });

      if (found > -1) {
        selectedSubjects.splice(found, 1);
      } else {
        selectedSubjects.push(subject);
      }

      _this.setState({
        selectedSubjects: selectedSubjects
      });
    });

    _this.state = {
      category: '',
      loading: true,
      selectedSubjects: []
    };
    return _this;
  }

  _createClass(StudentAdjustmentForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;
      var allSelected = false;

      if (this.props.userSubjects != null) {
        allSelected = this.state.selectedSubjects.length == this.props.userSubjects.length;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container student-adjustment-form"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('choose-adjustment'), "*"), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: this.state.category,
        onChange: this.onCategoryChange
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, this.props.translate('choose-adjustment')), this.props.additionalAdjustments != null ? this.props.additionalAdjustments.map(function (adjustment) {
        if (adjustment.status != 'ACTIVE') return;
        return /*#__PURE__*/React.createElement("option", {
          key: 'adjustment-' + adjustment.id,
          value: adjustment.id
        }, adjustment.title, adjustment.subTitle != null ? ' - ' + adjustment.subTitle : null);
      }) : null, /*#__PURE__*/React.createElement("option", {
        value: "extra_field"
      }, this.props.translate('Other (Creates new template)'))))), this.state.category == 'extra_field' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Template title'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: "input",
        type: "text",
        name: "subTitle",
        validate: this.required
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Template description'), "*"), /*#__PURE__*/React.createElement("div", {
        className: "description-alert"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert",
        bw: true
      }), " ", this.props.translate("Do not write information about a specific student in the template's description text")), /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "adjustmentDescription",
        validate: this.editorRequired,
        translate: this.props.translate
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Description for current student'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "description",
        validate: this.editorRequired,
        translate: this.props.translate
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.userSubjects != null && this.props.userSubjects.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, this.props.translate('choose-subjects')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: this.selectAllSubjects,
        label: this.props.translate('select-all'),
        value: allSelected
      })), this.props.userSubjects.map(function (subject) {
        var disabled = false;
        var selected = _this2.state.selectedSubjects.findIndex(function (sel) {
          return sel.id == subject.id;
        }) > -1;

        if (_this2.props.course != null) {
          disabled = _this2.props.course.subjectCode == subject.subjectCode;
        }

        if (_this2.props.subjectId != null) {
          disabled = _this2.props.subjectId == subject.id;
        }

        var title = subject.title;

        if (subject.typeOfSchooling != null) {
          title += " (".concat(_this2.props.translate(subject.typeOfSchooling), ")");
        }

        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '.35rem',
            marginLeft: '.85rem'
          },
          key: subject.id
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: selected,
          onChange: function onChange() {
            return _this2.onSubjectToggle(subject);
          },
          label: title,
          disabled: disabled
        }));
      })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, this.props.translate('choose-subjects')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.35rem'
        }
      }, this.props.translate('No subjects available for this user')))), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row submit spacing"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || this.state.category == ''
      }, this.props.translate('save')), this.props.onClose != null ? /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onCancel
      }, this.props.translate('Cancel'))) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }]);

  return StudentAdjustmentForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    studyPlans: state.Verdicts.userStudyPlans,
    additionalAdjustments: state.AdditionalAdjustments.adjustments,
    userSubjects: state.user.userSubjects,
    createdAdjustment: state.AdditionalAdjustments.createdAdjustment
  };
}

export default connect(mapStateToProps, {
  getUserStudyPlan: getUserStudyPlan,
  searchCourseByTitle: searchCourseByTitle,
  getAdditionalAdjustments: getAdditionalAdjustments,
  getUserSubjects: getUserSubjects,
  createAdditionalAdjustment: createAdditionalAdjustment,
  createStudentAdjustment: createStudentAdjustment,
  change: change
})(reduxForm({
  form: 'StudentAdjustmentForm',
  destroyOnUnmount: true
})(StudentAdjustmentForm));